import { Constants } from "./constants";

// Legacy breed group names on breed records, keyed by the group's sanctioning club
const BREED_GROUP_ALIASES: Record<string, Record<string, string>> = {
  [Constants.sanctioning_club.UKC]: {
    "Herding": "Herding Dogs",
  },
};

export function normalizeBreedGroupValue(sanctioningClub: string | undefined, value: string): string;
export function normalizeBreedGroupValue(sanctioningClub: string | undefined, value: string | undefined): string | undefined;
export function normalizeBreedGroupValue(sanctioningClub: string | undefined, value: string | undefined): string | undefined {
  if (!sanctioningClub || !value) {
    return value;
  }

  return BREED_GROUP_ALIASES[sanctioningClub]?.[value] ?? value;
}
